import React from 'react';
import { Card } from '@primitives';
import PDFFileIcon from '@cp/assets/images/icons/PDFFileIcon';
import { VisibilityIcon } from '@icons';
import { getFileDownload } from '@cp/utils/commonUtils';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { useParams } from 'react-router-dom';
import clickStreamConstant from '@cp/src/service/clickStream.constant';
import { clickStreamConstants } from '@cp/pages/CaseDetails/components/AllDocumentsV2/clickStreamConstants';

type PdfDocumentProps = {
  type: string;
  uri: string;
  isLoading: boolean;
  isDynamic: boolean;
  generateDocument: () => void;
  documentName: string;
};
function PdfDocument(document: PdfDocumentProps) {
  const { loanId = '', customerId = '' } = useParams();

  const handleFileDownload = (url: string) => {
    addClickstreamEvent(clickStreamConstants.LH_DOCUMENT_DOWNLOAD_CLICKED, {
      lan: loanId,
      document_name: document.documentName,
      document_type: 'pdf'
    });
    getFileDownload(url, true);
  };
  return (
    <Card
      className="cursor-pointer bg-primary shadow-2 flex items-center gap-3 justify-between min-w-[247px]"
      onClick={() => handleFileDownload(document.uri)}
    >
      <div className="flex gap-2 items-center">
        <PDFFileIcon />
        <div className="text-xs">{document?.documentName} </div>
      </div>
      <div>
        <VisibilityIcon color={'var(--blue-base)'} variant={'outlined'} size="sm" />
      </div>
    </Card>
  );
}

export default PdfDocument;
